import type { TFunction } from 'i18next';
import shellEn from 'locales/en/recruiter/shell.json';
import { backendLabelOr } from 'recruiter-i18n/backendText';
import type { CORE_NS } from 'recruiter-i18n/namespaces/core';
import type { SHELL_NS } from 'recruiter-i18n/namespaces/shell';

import {
  plainProductUpdateText,
  type ProductUpdate,
} from './parseProductUpdates';

export type WhatsNewText = TFunction<[typeof SHELL_NS, typeof CORE_NS]>;

type TagKey = keyof typeof shellEn | 'core:fields.settings';

const TAG_KEYS: ReadonlyMap<string, TagKey> = new Map<string, TagKey>([
  ['Announcements', 'whatsNew.tags.announcements'],
  ['Interviews', 'nav.interviews'],
  ['Analytics', 'nav.analytics'],
  ['Sourcing', 'nav.sourcing'],
  ['Settings', 'core:fields.settings'],
]);

/** Translate current release copy without changing its identity or eligibility. */
export function productUpdateCopy(
  update: ProductUpdate,
  t: WhatsNewText
): Pick<ProductUpdate, 'title' | 'summary'> {
  return {
    title: plainProductUpdateText(
      backendLabelOr(
        t,
        shellEn,
        `whatsNew.updates.${update.id}.title`,
        update.title
      )
    ),
    summary: plainProductUpdateText(
      backendLabelOr(
        t,
        shellEn,
        `whatsNew.updates.${update.id}.summary`,
        update.summary
      )
    ),
  };
}

/** Shared feature labels translate together; newly authored tags keep their wording. */
export function productUpdateTag(tag: string, t: WhatsNewText): string {
  const key = TAG_KEYS.get(tag);
  return key ? t(key) : tag;
}
